// Runs a block initializer on the frontend (once the DOM is ready) or after
// every ACF preview render in the editor. The initializer receives the root
// to search in and `{ isEditor }`.
export default function bootBlock(slug, init) {
  const { acf, wp } = window;

  if (acf?.addAction && wp?.blocks) {
    acf.addAction(`render_block_preview/type=${slug}`, ($block) => {
      const root = $block?.jquery ? $block.get(0) : $block;
      if (root) {
        init(root, { isEditor: true });
      }
    });
    return;
  }

  const run = () => init(document, { isEditor: false });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
}

// Third-party UI constructors must come from the preview's own window.
export function whenGlobal(win, name, callback) {
  if (win[name]) {
    callback(win[name]);
    return;
  }
  win.addEventListener('load', () => {
    if (win[name]) {
      callback(win[name]);
    }
  }, { once: true });
}

// One listener set per document and block type; a re-render replaces it.
export function documentSignal(doc, key, instance) {
  const store = doc.juniperBlockSignals || new Map();
  // eslint-disable-next-line no-param-reassign
  doc.juniperBlockSignals = store;
  const id = instance ? `${key}:${instance.closest('[data-block]')?.dataset.block || ''}` : key;
  store.get(id)?.abort();
  const controller = new AbortController();
  store.set(id, controller);
  return controller.signal;
}
